"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeprecatedSetReservationListInstruction = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const SetReservationListArgs_1 = require("../types/SetReservationListArgs");
const DeprecatedSetReservationListStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['setReservationListArgs', SetReservationListArgs_1.setReservationListArgsBeet],
], 'DeprecatedSetReservationListInstructionArgs');
const deprecatedSetReservationListInstructionDiscriminator = 5;
function createDeprecatedSetReservationListInstruction(accounts, args) {
    const { masterEdition, reservationList, resource } = accounts;
    const [data] = DeprecatedSetReservationListStruct.serialize({
        instructionDiscriminator: deprecatedSetReservationListInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: masterEdition,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: reservationList,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: resource,
            isWritable: false,
            isSigner: true,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s'),
        keys,
        data,
    });
    return ix;
}
exports.createDeprecatedSetReservationListInstruction = createDeprecatedSetReservationListInstruction;
//# sourceMappingURL=DeprecatedSetReservationList.js.map